module.exports = __webpack_public_path__ + "img/icon-done.026b90df.svg";